import React, { ReactNode } from "react";

interface BreadcrumbsContainerProps {
    children: ReactNode;
    isMobile: boolean;
    settings: any;
}

const BreadcrumbsContainer: React.FC<BreadcrumbsContainerProps> = ({ children, isMobile, settings }) => {
    const { section } = settings || {};
    const alignment = section?.content_alignment || "left";
    
    return (
        <div className={`breadcrumbs-container text-${alignment}`}>
            <nav aria-label="breadcrumb" className="breadcrumb-container">
                <ol
                    className={`breadcrumb ${section?.text_style}`}
                    itemScope
                    itemType="http://schema.org/BreadcrumbList"
                >
                    {children}
                </ol>
            </nav>
        </div>
    );
};

export default BreadcrumbsContainer;
